import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useAdhesionKits = (method, distributor_id = null) => useQuery({ queryKey: [`adhesion-kits`, method, distributor_id], queryFn: async () => {
    if(!method) return []
    if(method==='distributor' && !distributor_id) return []
    const callback = await API.get(`/adhesion/kits?method=${method}${!!distributor_id ? `&distributor_id=${distributor_id}` : ''}`)
    return callback?.data
}, staleTime: 1000 * 30 })

export default useAdhesionKits